import { IMMEDIATE_FEATURES } from 'utils/experiment';
import { OPTIMIZELY_VARIATION_ORIGINAL, OPTIMIZELY_VARIATION_REFRESHED, useFeatureVariation, } from 'plugins/optimizely/hooks/use-feature-variation';
import { useReduxSearchState } from 'pages/search/hooks/use-redux-search-state';
// Experiment hook to determine if the Mobile Web V2 Date/Timepicker experiment should be shown
export const useMobileWebV2DateTimepickerExperiment = () => {
    const { parkingType } = useReduxSearchState();
    const variation = useFeatureVariation(IMMEDIATE_FEATURES.ACQUISITION_MOBILE_WEB_V2_DATETIME_PICKER);
    if (parkingType === 'airport' || parkingType === 'event_package') {
        return {
            enabled: false,
            variation: OPTIMIZELY_VARIATION_ORIGINAL,
        };
    }
    return {
        enabled: variation === OPTIMIZELY_VARIATION_REFRESHED,
        variation,
    };
};
